import { AddressesEffects } from './additions.effect';
import { WasteCardNumberEffects } from './waste-card-number.effect';

export const effects = [AddressesEffects, WasteCardNumberEffects];
export * from './additions.effect';
